import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Formik, Form } from "formik";
import Input from "../../components/common/inputs/Input";
import { postApi } from "../../services/api/globalApi";
import {
  loginOtpValidate,
  loginGoogleTotpValidate,
} from "../../utils/validations/loginValidate";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import { covertNumberToEn } from "../../utils/converNumberToEn";

export default function Login() {
  const navigate = useNavigate();
  const [type, setType] = useState("otp");

  const sendOtpCode = async (values) => {
    try {
      const path = "api/otps";
      const body = { mobile: covertNumberToEn(values.mobile) };

      await postApi({ path, body });

      successMessage("کد OTP ارسال شد.");
    } catch (error) {
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  const login = async (values) => {
    try {
      const body = JSON.stringify({
        ...values,
        type,
        mobile: covertNumberToEn(values.mobile),
      });

      await postApi({ path: "admin/auth", body });

      successMessage("شما با موفقیت وارد شدید.");
      localStorage.setItem("liResponse", 1);
      navigate("/");
    } catch (error) {
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  return (
    <section className="bg-gray-50 dark:bg-gray-900">
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <div className="w-full bg-white rounded-lg shadow dark:border sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div className="flex mt-4 items-center justify-center mb-6 font-semibold text-gray-900 dark:text-white">
            <img
              className="w-36 mr-2"
              src={require("./../../assets/images/newLogo.png")}
              alt="logo"
            />
          </div>

          <div className="flex justify-around border-b border-gray-200 dark:border-gray-700">
            <button
              className={`w-1/2 py-2 text-center ${
                type === "otp"
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-gray-500"
              }`}
              onClick={() => {
                setType("otp");
              }}
            >
              ورود با OTP
            </button>
            <button
              className={`w-1/2 py-2 text-center ${
                type === "password"
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-gray-500"
              }`}
              onClick={() => {
                setType("password");
              }}
            >
              ورود با رمز عبور
            </button>
          </div>

          <Formik
            initialValues={{
              mobile: "",
              code: "",
              password: "",
            }}
            validationSchema={
              type === "otp" ? loginOtpValidate : loginGoogleTotpValidate
            }
            onSubmit={login}
          >
            {(formik) => (
              <Form className="space-y-4 md:space-y-6 p-6 pt-0">
                <Input
                  name="mobile"
                  placeholder="موبایل"
                  label="موبایل"
                  type="text"
                  className="flex-1"
                />

                {type === "otp" && (
                  <>
                    <Input
                      name="password"
                      placeholder="رمز عبور"
                      label="رمز عبور"
                      type="password"
                    />
                    <div className="flex items-center gap-2 w-full">
                    <Input
                      name="code"
                      placeholder="کد OTP"
                      label="کد OTP"
                      type="text"
                    />
                      {type === "otp" && (
                        <button
                          type="button"
                          onClick={() => sendOtpCode(formik.values)}
                          className="bg-blue-600 text-white px-4 py-2 mt-7 rounded-lg text-sm w-auto"
                        >
                          دریافت کد
                        </button>
                      )}
                    </div>
                  </>
                )}

                {type === "password" && (
                  <Input
                    name="password"
                    placeholder="رمز"
                    label="رمز totp"
                    type="password"
                  />
                )}

                <button
                  type="submit"
                  className="w-full text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >
                  ورود
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </section>
  );
}
